export function isValidImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => reject(new Error("Image could not be loaded from the URL")); 

        img.src = src; 
    });
}